
    <span   class="lnm" [class.favorite]="isFav" (mouseover)="hovered=true" (mouseout)="hovered=false"> 
    <span   class="lnm"  (mouseover)="hovered=true" (mouseout)="hovered=false">
<mat-icon *ngIf="showStar" (click)="toggleFav($event)">{{favorite}}</mat-icon>


</span>